<template lang="html">
  <b-form-file
    ref="file-input"
    v-model="file"
    :drop-placeholder="$t('message.generic.form.dropFile')"
    :browse-text="$t('message.generic.form.browse')"
    v-bind="$attrs"
    @change="handleChange"
    v-on="mountEventListeners">
    <template
      #placeholder>
      <span v-if="showName === true">{{ $t('message.generic.form.selectFile') }} </span>
      <span
        v-if="showName === false"
        class="color_dark"><coozzy-paper-clip-icon class="mr-2" />{{ $t('message.generic.form.selectFile') }} </span>
    </template>
    <template
      #file-name="{names}">
      <section>
        <span v-if="showName === true">{{ names[0] }}</span>
        <span
          v-if="showName === false"
          class="color_light">
          <coozzy-paper-clip-icon class="mr-2" />{{ $t('message.generic.form.selectFile') }}<coozzy-spinner class="spinner_personnalised ml-3" />
        </span>
      </section>
    </template>
  </b-form-file>
</template>

<script>
import CoozzyPaperClipIcon from '@/framework/components/icons/CoozzyPaperClipIcon'
import Vue from 'vue'
export default {
  name: 'CoozzyFormFileInput',
  components: {
    CoozzyPaperClipIcon
  },
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      default: ''
    },
    showName: {
      type: Boolean,
      default: true
    },
    maxFileSizeMb: {
      type: Number,
      default: 250
    }
  },
  data() {
    return {
      file: null
    }
  },
  computed: {
    mountEventListeners() {
      const { change, input, ...listeners } = this.$listeners
      return listeners
    },
    maxFileSizeBytes() {
      return this.maxFileSizeMb * 1024 * 1024
    }
  },
  methods: {
    handleChange(event) {
      const files = this.extractFiles(event)
      const exceedsLimit = files.some(file => file && file.size > this.maxFileSizeBytes)

      if (exceedsLimit) {
        Vue.toasted.show(this.$tc('message.uploadingErrors.maxTotalFilesSize250MB'), { type: 'error' })
        this.file = null
        this.resetPlaceholder()
        this.$emit('file-too-large', { files, maxFileSizeBytes: this.maxFileSizeBytes, maxFileSizeMb: this.maxFileSizeMb })
        return
      }

      this.$emit('change', event)
      this.$emit('input', event)
    },
    extractFiles(event) {
      if (event?.target?.files?.length) {
        return Array.from(event.target.files)
      }
      if (event?.dataTransfer?.files?.length) {
        return Array.from(event.dataTransfer.files)
      }
      if (event && event.length && event[0]?.size !== undefined) {
        return Array.from(event)
      }
      if (Array.isArray(event)) {
        return event
      }
      if (event && event.size !== undefined) {
        return [event]
      }
      return []
    },
    resetPlaceholder() {
      this.file = null
      this.$refs['file-input'].reset()
    }
  }
}
</script>

<style lang="scss" scoped>
  .custom-file-label {
    box-shadow: 1px 1px 6px #ccc;
    font-size: 0.875rem;
    padding-left: 8px!important;
    cursor: pointer;
  }
  .spinner_personnalised {
    width: 1rem !important;
    height: 1rem !important;
    border-width: 0.15em !important;
  }

  .color_dark {
    color: #333;
  }
  .color_light{
    color: #495057;
    font-weight: 300;
  }
</style>
